import { NavigateOptions, To } from 'react-router-dom';

import { SECURE_URL_PARAMS, UP_DEV } from 'constants/urlParams';

export const routerHelper = (to: string, currentSearch: string) => {
    const currentSearchParams = new URLSearchParams(currentSearch);

    SECURE_URL_PARAMS.forEach((authParam) => currentSearchParams.delete(authParam));

    const mergeQueryParams = (): string => {
        const [path, existingSearch = ''] = to.split('?');
        const toParams = new URLSearchParams(existingSearch);

        currentSearchParams.forEach((value, key) => {
            if (!toParams.has(key)) {
                toParams.set(key, value);
            }
        });

        const mergedSearch = toParams.toString();

        return mergedSearch ? `${path}?${mergedSearch}` : to;
    };

    return {
        mergeQueryParams,
        isPersistNeeded: Boolean(currentSearchParams.get(UP_DEV)),
    };
};

export const overriddenNavigate =
    (originalNavigate: { (to: number): Promise<void>; (to: To | null, options?: NavigateOptions): Promise<void> }) =>
    async (to: number | To | null, options?: NavigateOptions): Promise<void> => {
        if (to === null) {
            // Handle the case when 'to' is null; just call the original navigate
            return originalNavigate(to, options);
        } else if (typeof to === 'number') {
            // Handle navigating by history steps (e.g., back or forward)
            return originalNavigate(to);
        } else {
            // On reload TO is an object {pathname, search, hash}
            const toStr = typeof to === 'object' ? (to as any).pathname : to;

            // Normal URL-based navigation with query parameter merging
            const { mergeQueryParams, isPersistNeeded } = routerHelper(toStr, window.location.search);

            const destination = isPersistNeeded ? mergeQueryParams() : toStr;

            return originalNavigate(destination, options);
        }
    };
